import { GetApp } from "../../App"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { IShipVesselType, IUnitDefault } from "../../Types"
import { PrintShipViewData } from "./Context"
import { PrintShipDimensionsViewProps } from "./Params"

// Dimensions, materials and (for sailing yachts) rig totals, plus the vessel sketch.
export function PrintShipDimensionsView({ data }: PrintShipDimensionsViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { shipData, ship } = PrintShipViewData.resolveShipData(data);

  return (
    <PrintListBlock
      title={t("dimensions")}
      blockClassName="PrintShipView-block-left"
      after={(
        <Block className="PrintShipView-block-image">
          {(shipData?.shipType || ship?.vesselType) && <img src={"/ship-" + (shipData?.shipType || (ship?.vesselType === IShipVesselType.motor ? "motor-boat" : "sailing-sloop")) + ".svg"} />}
        </Block>
      )}
    >
      <BlockRow>
        <BlockField label={t("height")} className="block-field-165">{shipData?.height != null ? shipData.height.toLocaleString(navigator.language) : ""} {shipData?.heightUnit || (shipData?.height ? IUnitDefault.length : "")}</BlockField>
        <BlockField label={t("draft")} className="block-field-165">{shipData?.draft != null ? shipData.draft.toLocaleString(navigator.language) : ""} {shipData?.draftUnit || (shipData?.draft != null ? IUnitDefault.length : "")}</BlockField>
        <BlockField label={t("beam")} className="block-field-165">{shipData?.beam != null ? shipData.beam.toLocaleString(navigator.language) : ""} {shipData?.beamUnit || (shipData?.beam ? IUnitDefault.length : "")}</BlockField>
      </BlockRow>

      <BlockRow>
        <BlockField label={t("length_waterline")} className="block-field-165">{shipData?.lengthWaterline != null ? shipData.lengthWaterline.toLocaleString(navigator.language) : ""} {shipData?.lengthWaterlineUnit || (shipData?.lengthWaterline ? IUnitDefault.length : "")}</BlockField>
        <BlockField label={t("length_hull")} className="block-field-165">{shipData?.lengthHull != null ? shipData.lengthHull.toLocaleString(navigator.language) : ""} {shipData?.lengthHullUnit || (shipData?.lengthHull ? IUnitDefault.length : "")}</BlockField>
        <BlockField label={t("length")} className="block-field-165">{shipData?.length != null ? shipData.length.toLocaleString(navigator.language) : ""} {shipData?.lengthUnit || (shipData?.length ? IUnitDefault.length : "")}</BlockField>
      </BlockRow>

      <BlockRow>
        <BlockField label={t("displacement")} className="block-field-165">{shipData?.displacement != null ? shipData.displacement.toLocaleString(navigator.language) : ""} {shipData?.displacementUnit || (shipData?.displacement ? IUnitDefault.weight : "")}</BlockField>
        <BlockField label={t("keel_weight")} className="block-field-165">{shipData?.keelWeight != null ? shipData.keelWeight.toLocaleString(navigator.language) : ""} {shipData?.keelWeightUnit || (shipData?.keelWeight ? IUnitDefault.weight : "")}</BlockField>
        <BlockField label={t("keel_weight_percent")} className="block-field-165">{shipData?.keelWeightPercent}{shipData?.keelWeightPercent ? " %" : ""}</BlockField>
      </BlockRow>

      <BlockRow>
        <BlockField label={t("hull_material")} className="block-field-165">{shipData?.hullMaterial} </BlockField>
        <BlockField label={t("hull_color")} className="block-field-165">{shipData?.hullColor} </BlockField>

      </BlockRow>

      <BlockRow>
        <BlockField label={t("keel_material")} className="block-field-165">{shipData?.keelMaterial} </BlockField>
        <BlockField label={t("keel_shape")} className="block-field-165">{shipData?.keelShape} </BlockField>
      </BlockRow>

      {shipData?.vesselType === 2 && (
        <BlockRow>
          <BlockField label={t("masts_no")} className="block-field-165">{shipData?.masts}</BlockField>
          <BlockField label={t("rig")} className="block-field-165">{shipData?.rig}</BlockField>
          <BlockField label={t("sail_area_total")} className="block-field-165">{shipData?.sailAreaTotal} {shipData?.sailAreaTotalUnit || (shipData?.sailAreaTotal ? IUnitDefault.surface : "")}</BlockField>
        </BlockRow>
      )}

      <BlockRow>
        <BlockField label={t("special_features")}>{shipData?.specialFeatures}</BlockField>
      </BlockRow>
    </PrintListBlock>
  );
}
